const appLoadingState = {
    bundleLoaded: false,
    applicationLoaded: false,
    ready: false,
    onReadyCallback: undefined,
};

export function bundleLoaded() {
    appLoadingState.bundleLoaded = true;
    checkAndEmitLoadingStatus();
}

export function applicationDataLoaded() {
    appLoadingState.applicationLoaded = true;
    checkAndEmitLoadingStatus();
}

export function onApplicationReady(callback) {
    appLoadingState.onReadyCallback = callback;
}

function checkAndEmitLoadingStatus() {
    if (
        !appLoadingState.ready &&
        appLoadingState.bundleLoaded &&
        appLoadingState.applicationLoaded
    ) {
        appLoadingState.ready = true;
        appLoadingState.onReadyCallback?.();
    }
}